<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="card card--white">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <a @click="link_xls()" class="btn btn-primary">
              <i class="fa fa-file-excel"></i>
              Exportar Archivo Sinader
            </a>
            <br>
            <!-- <a @click="link_xls_anio(2021)" class="btn btn-primary" >
              <i class="fa fa-file-excel"></i>
              Exportar Archivo Resumen 2021
            </a> -->
            <a @click="link_xls_anio(anioAnterior)" class="btn btn-primary">
              <i class="fa fa-file-excel"></i>
              Exportar Archivo Resumen {{ anioAnterior }}
            </a>
            <br>
            <div v-if="error" class="alert alert-warning" role="alert">{{ error }}</div>
          </div>
          <div class="col-md-6">
            <i class="fas fa-file-pdf"></i> <a target="_blank" href="/files/Instructivo Carga Masiva error patentes.pdf"
              class="">Instructivo Carga Masiva error patentes</a><br>
            <i class="fas fa-file-pdf"></i> <a target="_blank"
              href="/files/Instructivo Carga Masiva error destinatario.pdf" class="">Instructivo Carga Masiva error
              destinatario</a><br>
            <!-- <i class="fas fa-file-pdf"></i> <a target="_blank" href="/files/Instructivo Declaración Anual 2020.pdf" class="">Instructivo Declaración Anual 2021</a> -->
          </div>
        </div>
        <div v-if="errorFecha" class="alert alert-primary" role="alert">
          {{ errorFecha }}
        </div>
        <div class="alert alert-primary" role="alert">
          Existen {{ sinaders.length }} registros para el periodo seleccionado.
          <span v-if="contarIncompletas() > 0">De los cuales deberá cargar las patentes manualmente en SINADER para
            {{ contarIncompletas() }} registros, antes de subir el archivo de carga masiva.</span>
        </div>
        <div class="row" v-if="!errorFecha">
          <div class="col-md-12">
            <table class="table table--secondary">
              <thead>
                <tr>
                  <th>LER</th>
                  <th>Rut</th>
                  <th>Establecimiento</th>
                  <th>Tratamiento</th>
                  <th>Cantidad</th>
                  <th>Rut Transportista</th>
                  <th>Patente</th>
                  <th>Fecha</th>
                  <th>Código Gestión</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sinader in sinaders" v-bind:key="sinader.id">
                  <td>{{ sinader.ler }}</td>
                  <td>{{ sinader.rut || sinader.rut_establecimiento_receptor }}</td>
                  <td
                    v-bind:class="{ 'missingPatente': !sinader.establecimiento && !sinader.codigo_establecimiento_receptor }">
                    {{ sinader.establecimiento || sinader.codigo_establecimiento_receptor || '-----' }}</td>
                  <td v-bind:class="{ 'missingPatente': !sinader.tratamiento && !sinader.codigo_tratamiento_receptor }">
                    {{ sinader.tratamiento || sinader.codigo_tratamiento_receptor || '-----' }}</td>
                  <td>{{ sinader.cantidad }}</td>
                  <td v-bind:class="{ 'missingPatente': sinader.has_tipo_incompleto_vehiculo }">{{
              sinader.transporte_rut
              || sinader.rut_transportista }}</td>
                  <td v-bind:class="{ 'missingPatente': sinader.has_tipo_incompleto_vehiculo }">{{ sinader.patente }}
                  </td>
                  <td>{{ sinader.fecha | moment("DD MMM YY") }}</td>
                  <td><span>{{ sinader.gestion }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { utils } from '@/utils.js'
import Breadcrumb from '@/components/Breadcrumb.vue'

export default {
  name: 'Sinader',
  mixins: [utils],
  components: { Breadcrumb },
  props: {},
  data () {
    return {
      sinaders: [],
      error: null,
      anioAnterior: null
    }
  },
  methods: {
    inicializaAnio () {
      const fechaActual = new Date()
      this.anioAnterior = fechaActual.getFullYear() - 1
    },
    contarIncompletas () {
      return this.sinaders.filter(s => {
        return s.has_tipo_incompleto_vehiculo
      }).length
    },
    search () {
      this.error = null
      axios.get('/portal/sinader/' + this.$route.params.id, {
        params: {
          fecha__gte: this.$route.query.desde,
          fecha__lte: this.$route.query.hasta
        }
      })
        .then(res => {
          this.sinaders = res.data
        }).catch(error => {
          this.errorFecha = error.response.data.message
        })
    },
    link_xls () {
      var self = this
      self.error = null
      self.isDownloading = true
      var url = process.env.VUE_APP_API_MAIN +
        '/portal/sinader/xls/' + this.$route.params.id + '/' +
        this.$route.query.desde.split('-')[0] * 1 + '/' +
        this.$route.query.desde.split('-')[1] * 1 + '/'
      axios
        .get(url, { responseType: 'arraybuffer' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'ArchivoSinader.xlsx')
          document.body.appendChild(link)
          link.click()
          self.isDownloading = false
        })
        .catch(function (error) {
          console.log(error.response)
          self.error = 'No es posible exportar, periodo todavía no cerrado y debe ser validado por Eco-Lógica'
        })
    },
    link_xls_anio (year) {
      var self = this
      self.error = null
      self.isDownloading = true
      var url = process.env.VUE_APP_BASEURL + '/portal/sinader/xls_anio/' + this.$route.params.id + `/${year}/`
      axios
        .get(url, { responseType: 'arraybuffer' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `ArchivoSinader${year}.xlsx`)
          document.body.appendChild(link)
          link.click()
          self.isDownloading = false
        })
        .catch(function (error) {
          console.log(error.response)
          self.error = 'No es posible exportar, periodo todavía no cerrado y debe ser validado por Eco-Lógica'
        })
    }
  },
  mounted () {
    // if (this.validate_rango_fecha()) {
    this.inicializaAnio()
    this.search()
    // }
  }
}
</script>
